import { render, staticRenderFns } from "./Turnos.vue?vue&type=template&id=b86fe1e2&"
import script from "./Turnos.vue?vue&type=script&lang=js&"
export * from "./Turnos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports